(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('autre-activite', {
            parent: 'entity',
            url: '/autre-activite?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.autreActivite.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/autre-activite/autre-activites.html',
                    controller: 'AutreActiviteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('autreActivite');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('autre-activite-detail', {
            parent: 'entity',
            url: '/autre-activite/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.autreActivite.detail.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/autre-activite/autre-activite-detail.html',
                    controller: 'AutreActiviteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('autreActivite');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AutreActivite', function($stateParams, AutreActivite) {
                    return AutreActivite.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'autre-activite',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('autre-activite-detail.edit', {
            parent: 'autre-activite-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/autre-activite/autre-activite-dialog.html',
                    controller: 'AutreActiviteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AutreActivite', function(AutreActivite) {
                            return AutreActivite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('autre-activite.new', {
            parent: 'autre-activite',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/autre-activite/autre-activite-dialog.html',
                    controller: 'AutreActiviteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('autre-activite', null, { reload: 'autre-activite' });
                }, function() {
                    $state.go('autre-activite');
                });
            }]
        })
        .state('autre-activite.edit', {
            parent: 'autre-activite',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/autre-activite/autre-activite-dialog.html',
                    controller: 'AutreActiviteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AutreActivite', function(AutreActivite) {
                            return AutreActivite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('autre-activite', null, { reload: 'autre-activite' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('autre-activite.delete', {
            parent: 'autre-activite',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/autre-activite/autre-activite-delete-dialog.html',
                    controller: 'AutreActiviteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AutreActivite', function(AutreActivite) {
                            return AutreActivite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('autre-activite', null, { reload: 'autre-activite' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
